<template>
  <div>
    <Spinner v-if="isLoading" />

    <div class="notification is-info" v-if="hasNoDogProfiles">No dog profiles found.</div>

    <div class="notification is-danger" v-if="loadError">{{ loadError }}</div>

    <DogProfilesList
      :user="user"
      :dogProfiles="dogProfiles"
      :usersCacheStorePath="usersCacheStorePath"
      v-if="dogProfilesLoaded"
      @delete-dog-profile="deleteDogProfile($event)"
    />

    <!-- Modals -->
    <UserDeleteDogProfileModal
      v-if="dogProfileToDelete != null"
      :userStorePath="userStorePath"
      :dogProfile="dogProfileToDelete"
      @cancelled="closeDeleteDogProfileModal"
      @succeeded="closeDeleteDogProfileModal"
    />
  </div>
</template>

<script>
import Spinner from '@/components/utils/Spinner'
import DogProfilesList from '@/modules/gps/DogProfilesList'
import UserDeleteDogProfileModal from './UserDeleteDogProfileModal'

import {
  LOAD_DOG_PROFILES,
  IS_LOADING_DOG_PROFILES,
  GET_DOG_PROFILES,
  GET_DOG_PROFILES_LOAD_ERROR,
  HAS_EMPTY_DOG_PROFILES_LOAD_RESULT
} from './userStore'

export default {
  name: 'UserDogProfilesTab',

  components: {
    DogProfilesList,
    UserDeleteDogProfileModal,
    Spinner
  },

  props: {
    user: {
      type: Object,
      required: true
    },

    userStorePath: {
      type: String,
      required: true
    },

    usersCacheStorePath: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      dogProfileToDelete: null
    }
  },

  mounted() {
    const loadDogProfilesAction = `${this.userStorePath}/${LOAD_DOG_PROFILES}`
    this.$store.dispatch(loadDogProfilesAction)
  },

  computed: {
    dogProfilesLoaded() {
      return this.dogProfiles !== null
    },

    isLoading() {
      const isLoadingDogProfiles = `${this.userStorePath}/${IS_LOADING_DOG_PROFILES}`
      return this.$store.getters[isLoadingDogProfiles]
    },

    hasNoDogProfiles() {
      const hasEmptyDogProfilesLoadResult = `${this.userStorePath}/${HAS_EMPTY_DOG_PROFILES_LOAD_RESULT}`
      return this.$store.getters[hasEmptyDogProfilesLoadResult]
    },

    dogProfiles() {
      const dogProfile = `${this.userStorePath}/${GET_DOG_PROFILES}`
      return this.$store.getters[dogProfile]
    },

    loadError() {
      const getDogProfilesLoadError = `${this.userStorePath}/${GET_DOG_PROFILES_LOAD_ERROR}`
      return this.$store.getters[getDogProfilesLoadError]
    }
  },

  methods: {
    deleteDogProfile(dogProfile) {
      this.dogProfileToDelete = dogProfile
    },

    closeDeleteDogProfileModal() {
      this.dogProfileToDelete = null
    }
  }
}
</script>
